import "normalize.css";
import "amfe-flexible";
import "animate.css";

import Vue from "vue";
import "@/utils/wxFontsize";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./filters";
import ajax from "./utils/ajax";
import { setShareConfig } from "@/utils/share";

// import * as fundebug from "fundebug-javascript";
// import fundebugVue from "fundebug-vue";
// import "fundebug-revideo";

import {
  Col,
  Row,
  Toast,
  Field,
  Cell,
  CellGroup,
  Button,
  NoticeBar,
  Swipe,
  SwipeItem,
  Dialog,
  Tab,
  Tabs,
  Empty,
  List,
  Image,
  Lazyload,
  Icon,
  Grid,
  GridItem,
  Notify,
  Popup,
  Rate,
  Progress,
  Picker,
  Cascader,
  CountDown,
  Circle,
} from "vant";
Vue.use(Col);
Vue.use(Row);
Vue.use(Toast);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(NoticeBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Dialog);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Empty);
Vue.use(List);
Vue.use(Image);
Vue.use(Lazyload);
Vue.use(Icon);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Notify);
Vue.use(Popup);
Vue.use(Rate);
Vue.use(Progress);
Vue.use(Picker);
Vue.use(Cascader);
Vue.use(CountDown);
Vue.use(Circle);

import { VueHammer } from "vue2-hammer";
VueHammer.config.swipe = {
  direction: 6,
};
Vue.use(VueHammer);

// if (process.env.NODE_ENV === "production") {
//   fundebug.apikey =
//     "a0f028355f137655c0e432b25627c03cbf0aa15e39e29c0f3550c204c98bed39";
//   fundebug.appversion = "1.2.9";
//   fundebug.releasestage = "production";
//   fundebug.setHttpBody = true;
//   fundebugVue(fundebug, Vue);
// }

Vue.prototype.$axios = ajax;

Vue.config.productionTip = false;
// 百度统计
import baiduAnalytics from "vue-baidu-analytics";
if (process.env.NODE_ENV === "production") {
  Vue.use(baiduAnalytics, {
    router: router,
    siteIdList: [
      "6ce2a5d55ca4b1b774e211899ca200ef",
      "680c610853e9c97b010ddcef12f3d1c1",
    ],
    isDebug: false,
  });
}
//神策统计
import sensors from "sa-sdk-javascript";
import pageleave from "sa-sdk-javascript/dist/web/plugin/pageleave/index.es6.js";

// 神策
sensors.use(pageleave, {});
sensors.init({
  server_url: `https://mdgj-sjdr.cast.org.cn/sa?project=${
    location.host.indexOf("weixinweb.kepuchina.cn") >= 0
      ? "production"
      : "default"
  }`,
  show_log: false,
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: "beacon",
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: "default",
    collect_tags: {
      div: true,
      span: true,
      img: true,
    },
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: "not_collect",
  },
});
sensors.registerPage({
  scene_name: "科普中国Lite",
});
sensors.quick("autoTrack");

// 默认分享配置
setShareConfig({
  link: location.origin + process.env.BASE_URL + "api",
  title: "科技改变生活 创新赢得未来",
  desc: "2026年山西省公众科学素质网络知识竞赛",
  img: location.origin + require("@/assets/share-download-img.jpg"),
  isShareImage: 1,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
